import { getUser } from 'src/utils/Common';
import moment from 'moment';
import axios from '../../utils/axios';

export const getTasks = () => {
  const SessionUser = getUser();
  let StartDate = sessionStorage.getItem('StartDate');
  let EndDate = sessionStorage.getItem('EndDate');
  const today = new Date();
  const todayFormat = moment(today).format('YYYY-MM-DD');
  if (StartDate === null) {
    StartDate = todayFormat;
  }
  if (EndDate === null) {
    EndDate = moment(today).add(1, 'days').format('YYYY-MM-DD');
  }

  let WorkOrderId = sessionStorage.getItem('WorkOrderId');
  if (WorkOrderId === null || WorkOrderId === undefined || WorkOrderId === "undefined" || WorkOrderId === "") {
    WorkOrderId = 0;
  }

  return axios.get(`/GetTechnicianWorkOrder/${SessionUser.TechnicianId}/${StartDate}/${EndDate}/${WorkOrderId}`);
};

export const getClosedJobs = () => {
  const SessionUser = getUser();
  let StartDate = sessionStorage.getItem('ClosedJobsStartDate');
  let EndDate = sessionStorage.getItem('ClosedJobsEndDate');
  const today = new Date();

  const todayFormat = moment(today).format('YYYY-MM-DD');

  if (StartDate === null) {
    StartDate = todayFormat;
  }
  if (EndDate === null) {
    EndDate = todayFormat;
  }

  return axios.get(`/GetTechnicianClosedJobs/${SessionUser.TechnicianId}/${StartDate}/${EndDate}`);
};

export const getUndatedTasks = () => {
  const SessionUser = getUser();
  return axios.get(`/GetTechnicianEmptyAppoinment/${SessionUser.TechnicianId}`);
};
export const getPendingJobs = () => {
  const SessionUser = getUser();
  return axios.get(`/GetWorkOrderTechStatus/${SessionUser.TechnicianId}`);
};
export const getActionRequired = () => {
  const SessionUser = getUser();
  return axios.get(`/GetActionRequired/${SessionUser.TechnicianId}`);
}

export const GetSiriusTodaySummary = () => {
  const SessionUser = getUser();
  return axios.get(`/GetSiriusTodaySummary/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`);
};

export const GetToaResourceActivities = () => {
  const SessionUser = getUser();
  let StartDate = sessionStorage.getItem('StartDate');
  const todayFormat = moment(StartDate).format('YYYY-MM-DD');
  return axios.get(`/GetToaResourceActivities/${todayFormat}/${SessionUser.TechnicianCode}`);
}

export const SetWorkOrderToCache = (Payload) => {
  const { WorkOrderId, TechnicianCode, AppointmentDate } = Payload.payload;
  const config = {
    headers: { 'Content-Type': 'application/json' }
  };

  const body = {
    Payload: Payload.payload.Payload,
    WorkOrderId: parseInt(WorkOrderId),
    TechnicianCode: parseInt(TechnicianCode),
    AppointmentDate: AppointmentDate
  }
  return axios.post('/SetWorkOrderToCache', body, config);
}

